import { render, staticRenderFns } from "./collectSchool.vue?vue&type=template&id=6a78c7cc&scoped=true&"
import script from "./collectSchool.vue?vue&type=script&lang=js&"
export * from "./collectSchool.vue?vue&type=script&lang=js&"
import style0 from "./collectSchool.vue?vue&type=style&index=0&id=6a78c7cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a78c7cc",
  null
  
)

export default component.exports